import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="photo-upload"
export default class extends Controller {
  static targets = ["preview"]
  
  connect() {
    console.log("Photo upload controller connected")
  }

  // Show preview when a file is selected
  previewImage(event) {
    const file = event.target.files[0]
    if (!file) return
    
    // Create a preview of the selected image
    const reader = new FileReader()
    
    reader.onload = (e) => {
      // Update the preview image with the selected file
      this.previewTarget.src = e.target.result
      
      // Make sure the preview is visible
      if (this.previewTarget.classList.contains('hidden')) {
        this.previewTarget.classList.remove('hidden')
      }
    }
    
    reader.readAsDataURL(file)
  }
  
  // Keep the original submit method for when the form is actually submitted
  submit(e) {
    e.target.disabled = true
    e.target.classList.add("bg-gray-400")
    e.target.value = "Guardando..."
    console.log("Form submitted")
    e.target.form.submit()
  }
}
